// ==================================
// actions/competitorAiTableActions.js
// ==================================

export const GENERATE_AI_TABLE_REQUEST = "GENERATE_AI_TABLE_REQUEST";

export const GENERATE_AI_TABLE_SUCCESS = "GENERATE_AI_TABLE_SUCCESS";

export const GENERATE_AI_TABLE_FAILURE = "GENERATE_AI_TABLE_FAILURE";

export const generateAiTableRequest = (payload) => ({
  type: GENERATE_AI_TABLE_REQUEST,
  payload,
});

export const generateAiTableSuccess = (data) => ({
  type: GENERATE_AI_TABLE_SUCCESS,
  payload: data,
});

export const generateAiTableFailure = (error) => ({
  type: GENERATE_AI_TABLE_FAILURE,
  payload: error,
});
